import { env } from '../env/env';
export const userAuthServiceConfig = {
    USER_AUTH_SERVICE_URL: env.getString('USER_AUTH_SERVICE_URL') || 'http://localhost:3434',
};
//# sourceMappingURL=userAuthServiceConfig.js.map